const days = (props) =>
  [
    {
      display: props.intl.formatMessage({ id: 'all_days' })
    },
    {
      display: props.intl.formatMessage({ id: 'monday' })
    },
    {
      display: props.intl.formatMessage({ id: 'tuesday' })
    },
    {
      display: props.intl.formatMessage({ id: 'wednesday' })
    },
    {
      display: props.intl.formatMessage({ id: 'thursday' })
    },
    {
      display: props.intl.formatMessage({ id: 'friday' })
    },
    {
      display: props.intl.formatMessage({ id: 'saturday' })
    },
    {
      display: props.intl.formatMessage({ id: 'sunday' })
    }
  ].map((day, dayId) => ({
    ...day,
    dayId
  }));

export { days };
